import { Helmet } from 'react-helmet-async';

const schema = {
  '@context': 'https://schema.org',
  '@type': 'ProfessionalService',
  name: 'Pricing Penguin',
  url: 'https://www.pricingpenguin.co.uk',
  logo: 'https://www.pricingpenguin.co.uk/logo.png',
  image: 'https://www.pricingpenguin.co.uk/logo512.png',
  description: 'AI-powered home improvement quoting platform connecting UK homeowners with trusted tradespeople. Get instant cost estimates for kitchens, bathrooms, extensions, and more.',
  telephone: '01296325153',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '32 High Street',
    addressLocality: 'Wendover',
    addressRegion: 'Buckinghamshire',
    postalCode: 'HP22 6EA',
    addressCountry: 'GB'
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 51.7612,
    longitude: -0.7469
  },
  areaServed: {
    '@type': 'Country',
    name: 'United Kingdom'
  },
  priceRange: 'Free for homeowners',
  // #678: removed a hardcoded aggregateRating (4.7 / 150) — it was not backed
  // by real, on-page reviews, which violates Google's review-snippet policy and
  // is a fabricated-trust risk. Re-add only when computed from verifiable reviews.
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'Home Improvement Cost Estimates',
    itemListElement: [
      {
        '@type': 'OfferCatalog',
        name: 'Kitchen Renovations',
        itemListElement: [{
          '@type': 'Offer',
          itemOffered: { '@type': 'Service', name: 'Kitchen Renovation Cost Estimate' }
        }]
      },
      {
        '@type': 'OfferCatalog',
        name: 'Bathroom Renovations',
        itemListElement: [{
          '@type': 'Offer',
          itemOffered: { '@type': 'Service', name: 'Bathroom Renovation Cost Estimate' }
        }]
      },
      {
        '@type': 'OfferCatalog',
        name: 'Loft Conversions',
        itemListElement: [{
          '@type': 'Offer',
          itemOffered: { '@type': 'Service', name: 'Loft Conversion Cost Estimate' }
        }]
      },
      {
        '@type': 'OfferCatalog',
        name: 'House Extensions',
        itemListElement: [{
          '@type': 'Offer',
          itemOffered: { '@type': 'Service', name: 'House Extension Cost Estimate' }
        }]
      }
    ]
  },
  sameAs: [
    'https://www.instagram.com/pricingpenguin/',
    'https://www.tiktok.com/@pricingpenguin',
    'https://www.linkedin.com/company/pricing-penguin-ltd/',
    'https://www.facebook.com/people/Pricing-Penguin/61575007326564/'
  ]
};

const LocalBusinessSchema = () => (
  <Helmet>
    <script type="application/ld+json">
      {JSON.stringify(schema)}
    </script>
  </Helmet>
);

export default LocalBusinessSchema;
